import { useChartState } from '@client/state/chart-state.hook';
import { createContext, FC, ReactNode, useContext } from 'react';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';
import { TradingFormState } from '../trading-form/trading-form.types';

interface LayoutContextValue {
  state: TradingFormState | null;
  chartId: string;
}

const initialValue: LayoutContextValue = {
  chartId: '',
  state: null
};

const LayoutContext = createContext<LayoutContextValue>(initialValue);

// Using content separately to not render until state is available,
// Mainly to avoid having to handle undefined state scenario
export const LayoutProvider: FC<{
  children: ReactNode;
  id: string;
}> = ({ children, id }) => {
  const { getChartById$ } = useChartState();
  const chart = useObservable(() => getChartById$(id));
  const state = chart?.formState;

  if (!state) return null;

  return (
    <LayoutContext.Provider value={{ state, chartId: id }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  return useContext(LayoutContext);
};
